// IMPORTS
// =============================================================
import $ from "jquery";
import { init as initFlyout } from "./modules/flyout.module.js";
import { init as initFlyoutSearch } from "./modules/flyout-search.module.js";

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
let attempts = 0;
const whenComplete = () => {
  if (++attempts > 30) return;
  if (document.readyState === "complete") {

    //Main menu
    initFlyout();

    //Site Search
    initFlyoutSearch();

    // -------------------------------------------------------------
    // MD modal
    // Import and init BS5 modal module when a modal is present
    // -------------------------------------------------------------

    if (document.querySelectorAll(".modal").length > 0) {
      import("./modules/modal.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD swiper
    // Import and init Swiper module when a slider is present
    // -------------------------------------------------------------
    if (document.querySelectorAll(".swiper-container").length > 0) {
      import("./modules/swiper.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelectorAll(".lightbox").length > 0) {
      import("./modules/lightbox.module.js").then((module) => {
        module.init();
      });
    }

    /*------------ .acc ---------*/
    $(".acc .acc__btn").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      var isActive = $this.parents('.acc__item').hasClass("active");

      var $acc = $this.closest(".acc");
      if ($acc.hasClass('active-one')) {
        $acc.find('.acc__item.active').removeClass('active').find('.acc__panel').slideUp(500);
      }

      if (isActive) {
        $this.parents('.acc__item').removeClass('active').find('.acc__panel').slideUp(500);
      } else {
        $this.parents('.acc__item').addClass('active').find('.acc__panel').slideDown(500);
      }
    });
    /*-------- /.acc ----------*/


  } else {
    setTimeout(() => whenComplete(), 400);
  }
};
whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
let styleAttempts = 0;
const stylesComplete = () => {
  if (++styleAttempts > 30) return;
  if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
    document.querySelector("#sess").remove();
  } else {
    setTimeout(() => stylesComplete(), 300);
  }
};
stylesComplete();
